import React from 'react';
import { onChangeNameValue, handleErrors } from 'services/utils';
import { Spinner }  from 'components/atoms';

export default class AbstractForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      item: props.item,
      busy: false,
      successSave: false,
    };
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.getFormData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.item !== prevProps.item) {
      this.setState({ item: this.props.item});
    }
  }

  getFormData() {}
  
  componentWillUnmount() {
    this.mounted = false;
  }

  propertyChanged = (e) => {
    const {propName, value} = onChangeNameValue(e);
    const item = this.state.item;
    item[propName] = value;
    this.setState({ item, successSave: false });
  }

  save = (e) => {
    e.preventDefault();
    this.setState({ successSave: false, busy:true });
    this.state.item.save().then((item) => {
      if (!this.mounted) return; 
      this.setState({ successSave: true, busy: false });
      if (this.props.onChange) {
        this.props.onChange(item);
      } else {
        this.setState({item});
      }
    }).catch((request) => {
      this.setState({busy: false});
      handleErrors(request);
    });
  }

  renderFields() {
    return null;
  }

  render() {
    return (
      <form onSubmit={this.save} className="col-md-12">

        {this.renderFields()}
        
        { this.state.successSave && 
         <div className="row alert alert-success">
          Запись успешно сохранена.
         </div>}

        <div className="row">
          <div className="col-md-12 mt-3 mb-3">
            <button type="submit" disabled={this.state.busy} className="btn btn-primary me-2">
              { this.state.busy && <Spinner /> }
              Сохранить
            </button>
            { this.props.onCancel && 
              <button type="button" onClick={this.props.onCancel} disabled={this.state.busy} className="btn btn-light">
                { this.state.busy && <Spinner /> }
                Назад
              </button>
            }
          </div>
        </div>
      </form>
    );
  }

}